
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full text-center p-6 bg-white rounded-lg shadow-md">
        <div className="flex justify-center mb-4">
          <AlertCircle className="h-12 w-12 text-red-500" />
        </div>
        <h1 className="text-4xl font-bold mb-2">404</h1>
        <p className="text-lg text-gray-600 mb-6">
          Oops! La página {location.pathname} no existe
        </p>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button asChild variant="default">
            <Link to="/">Regresar al inicio</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/workspace">Ir al workspace</Link>
          </Button>
        </div>
        <p className="mt-6 text-sm text-gray-500">
          Si crees que esto es un error, por favor contacta soporte.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
